const EDGE_SPACES_AND_TABS = /^[ \t]+|[ \t]+$/g

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (value === null || typeof value !== 'object') return false
  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

export const trimRequestValues = <T>(value: T): T => {
  if (typeof value === 'string') {
    return value.replace(EDGE_SPACES_AND_TABS, '') as T
  }

  if (Array.isArray(value)) {
    return value.map(item => trimRequestValues(item)) as T
  }

  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, trimRequestValues(item)]),
    ) as T
  }

  return value
}
